import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Center } from '~/commonComponents';

interface IInstructionItemProps {
  icon: string;
  title: string;
  description: string | React.ReactNode;
}

export const InstructionItem = ({ icon, title, description }: IInstructionItemProps) => {
  return (
    <Center>
      <img src={icon} style={{ width: 37, height: 37 }} alt="icon" />
      <Typography
        as="span"
        size="body_large"
        bold
        color={colors.primary[500]}
        textAlign="center"
        style={{ paddingTop: 14 }}
      >
        {title}
      </Typography>
      <Typography as="span" textAlign="center" color={colors.neutral[500]} style={{ paddingTop: 4 }}>
        {description}
      </Typography>
    </Center>
  );
};
